<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g id="icon">
      <rect
        x="3.5"
        y="3.5"
        width="5"
        height="5"
        rx="1"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="12.5"
        y="3.5"
        width="5"
        height="5"
        rx="1"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="3.5"
        y="12.5"
        width="5"
        height="5"
        rx="1"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.5,6h4M6,8.5v4M15,8.5v4"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13,13l3.5,3.5M16.5,13L13,16.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
